var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOffline = function SvgOffline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22280_63819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.46 36.0002C77.1 20.6402 55.7 15.0402 35.86 19.1202L45.94 29.2002C59.82 28.5202 73.9 33.4002 84.46 44.0002L92.46 36.0002ZM76.46 52.0002C71.3 46.8402 65.1 43.4802 58.5 41.7602L72.62 55.8802L76.46 52.0002ZM8.5 12.2002L20.78 24.4002C14.9 27.2802 9.38 31.1202 4.5 36.0002L12.46 44.0002C17.42 39.0402 23.14 35.3602 29.26 32.9202L38.22 41.8802C31.74 43.5602 25.58 46.9202 20.5 52.0002V52.0402L28.46 60.0002C33.9 54.5602 41.02 51.8402 48.14 51.7602L76.42 80.0002L81.5 74.9602L13.66 7.16016L8.5 12.2002ZM36.5 68.0002L48.5 80.0002L60.5 68.0002C53.9 61.3602 43.14 61.3602 36.5 68.0002Z",
    fill: "#FF6767"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22280_63819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
export default SvgOffline;